import { Navigate, Route, Routes } from "react-router-dom";
import { LoginView } from "../screens/LoginView";
import { ForgotPasswordView } from "../screens/ForgotPasswordView";
import { ChangePasswordView } from "../screens/ForgotPasswordView/ChangePasswordView";

//*Screens from ForgotPassword
//import { ForgotPassword } from "../screens/LoginView/forgot-password/ForgotPasswordView";
//import { ChangePasswordFirstLoginView } from "../screens/LoginView/change-password";

export default function AuthStack() {
  return (
    <Routes>
      <Route path="/" element={<LoginView />} />
      <Route path="/forgot-password" element={<ForgotPasswordView />} />
      <Route path="/change_password/:token" element={<ChangePasswordView />} />
      {/*<Route path="forgot-password" element={<ForgotPassword />} />
      //<Route path="change-password" element={<ChangePasswordFirstLoginView />} />
      */}
      {<Route path="/*" element={<Navigate to="/" />} />}
    </Routes>
  );
}
